import { addStyling } from '@plone/volto/helpers/Extensions/withBlockSchemaEnhancer';
import { defineMessages } from 'react-intl';

const messages = defineMessages({
  useFullBackgroundContainer: {
    id: 'Use full width colored background',
    defaultMessage: 'Use full width colored background',
  },
});
export const FullWidthStyle = ({ schema, formData, intl }) => {
  addStyling({ schema, intl });
  schema.properties.styles.schema.properties.fullwidth = {
    type: 'boolean',
    title: intl.formatMessage(messages.useFullBackgroundContainer),
  };
  schema.properties.styles.schema.fieldsets[0].fields.push('fullwidth');

  return schema;
};
